import { LinearProgress } from '@mui/material';
import styled from 'styled-components';

export const LinearProgressStyled = styled(LinearProgress)`
    background-color: #94d8ff;
`